// "Open in the Puttr app" for share links. On a phone with the app installed
// the universal link (iOS) / app link (Android) already opens the app before
// this page loads; this button is the fallback for in-app browsers and for
// players who tapped through to Safari. It tries the puttr:// scheme and,
// if nothing takes the foreground within a moment, sends them to the store.
import React from 'react';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/puttrco/id1528616307';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=co.puttr.android';

export function isAndroid() {
  return /android/i.test(navigator.userAgent);
}
export function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
export function isMobile() {
  return isAndroid() || isIOS();
}
export function storeUrl() {
  return isAndroid() ? PLAY_STORE_URL : APP_STORE_URL;
}

// path: 'game/595620' (same segments DeepLinkHandler.js parses in the app)
export function openInApp(path) {
  const start = Date.now();
  window.location.href = 'puttr://' + path;
  setTimeout(() => {
    if (document.hidden || document.visibilityState === 'hidden') return; // app took over
    if (Date.now() - start > 2500) return; // tab was suspended while the app opened
    window.location.href = storeUrl();
  }, 1500);
}

export default function OpenInApp({ path, className = 'btnGreen', label }) {
  if (isMobile()) {
    return (
      <button className={className} onClick={() => openInApp(path)}>
        {label || 'Open in the Puttr app'}
      </button>
    );
  }
  return (
    <a className={className} href={APP_STORE_URL} target="_blank" rel="noreferrer">
      {label || 'Get the Puttr app'}
    </a>
  );
}
